// src/services/api.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://54.91.179.2:8000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

// Strategy symbol mappings (matches backend)
export const STRATEGY_SYMBOLS = {
  vwap: ['SPY', 'NVDA', 'INTC', 'AMD', 'TSLA', 'NFLX', 'ORCL', 
    'AMZN', 'QQQ', 'AAPL', 'BAC', 'PFE', 'LYFT', 'T', 'GOOGL'],
  meanrev: [
    'GE', 'PARA', 'MS', 'MMM', 'GS', 'NVDA', 'DE', 'RTX',
    'C', 'GILD', 'FDX', 'AAPL', 'ABBV', 'XOM', 'XEL'
  ],
  momentum: [
    'BA', 'C', 'LMT', 'DIS', 'GOOGL', 'DE', 'TSLA', 'GOOG',
    'MPC', 'JNJ', 'GILD', 'UBER', 'SLB', 'AMGN', 'CAT'
  ]
};

export const STRATEGY_NAMES = {
  all: 'All Strategies',
  vwap: 'VWAP Intraday',
  meanrev: 'Daily Mean Reversion',
  momentum: 'Momentum + Sentiment'
};

// Helper: Determine which strategy owns a symbol
export const getSymbolStrategy = (symbol) => {
  if (!symbol) return 'unknown';
  if (STRATEGY_SYMBOLS.vwap?.includes(symbol)) return 'vwap';
  if (STRATEGY_SYMBOLS.momentum?.includes(symbol)) return 'momentum';
  if (STRATEGY_SYMBOLS.meanrev?.includes(symbol)) return 'meanrev';
  return 'unknown';
};

// Symbols
export const getSymbols = async () => {
  const response = await api.get('/symbols');
  return response.data;
};

// Bars (price data) - with smart aggregation
export const getBars = async (symbol, hours = 168) => {
  if (hours > 24) {
    const interval = hours > 168 ? '4h' : '1h';
    try {
      const response = await api.get(`/bars/${symbol}/aggregated?hours=${hours}&interval=${interval}`);
      return response.data;
    } catch (error) {
      console.warn('Aggregated endpoint failed, falling back to regular');
      const response = await api.get(`/bars/${symbol}?hours=${hours}`);
      return response.data;
    }
  } else {
    const response = await api.get(`/bars/${symbol}?hours=${hours}`);
    return response.data;
  }
};

// Portfolio
export const getAccount = async () => {
  const response = await api.get('/portfolio/account');
  return response.data;
};

export const getPositions = async () => {
  const response = await api.get('/portfolio/positions');
  return response.data;
};

export const getPortfolioHistory = async (period = '1M') => {
  const response = await api.get(`/portfolio/history?period=${period}`);
  return response.data;
};

// NEW: Multi-strategy summary
export const getMultiStrategySummary = async () => {
  const response = await api.get('/portfolio/multi-strategy-summary');
  return response.data;
};

// Trades
export const getOrders = async (status = 'all', limit = 100) => {
  const response = await api.get(`/trades/orders?status=${status}&limit=${limit}`);
  return response.data;
};

export const getActivities = async () => {
  const response = await api.get('/trades/activities');
  return response.data;
};

// Sentiment
export const getSentiment = async (symbol, days = 7) => {
  const response = await api.get(`/sentiment/${symbol}?days=${days}`);
  return response.data;
};

export const getSentimentAggregate = async (symbol, days = 30) => {
  const response = await api.get(`/sentiment/${symbol}/aggregate?days=${days}`);
  return response.data;
};

// NEW: Momentum endpoints
export const getMomentumPositions = async () => {
  const response = await api.get('/momentum/positions');
  return response.data;
};

export const getMomentumPerformance = async (days = 30) => {
  const response = await api.get(`/momentum/performance?days=${days}`);
  return response.data;
};

export const getMomentumTrades = async (limit = 50) => {
  const response = await api.get(`/momentum/trades?limit=${limit}`);
  return response.data;
};

export default api;